import React, { useState } from "react";
import { Card, InputNumber, Form, Input, Button, Select } from "antd";
import * as service from "./service";
import styles from "./index.module.less";
const FormItem = Form.Item;
const layoutItem = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};
const Cashier = () => {
  const [inputType, changeInputChange] = useState(1);
  const [data, changeData] = useState([]);
  const searchGoodsByCode = async ({ type, code }) => {
    const res = await service.getCurrLineGoodByCode({ type, code });
    if (res.data) {
      const resData = { ...res.data };
      const current = data.find((item) => item.goodsId === resData.goodsId);
      if (current) {
        current.count = current.count + 1;
        const newData = data.map((item) =>
          item.goodsId === current.goodsId ? current : item
        );
        changeData(newData);
      } else {
        resData.count = 1;
        changeData([resData, ...data]);
      }
    }
  };
  return (
    <div className={styles["page-cashier"]}>
      <div className="cashier-action">
        <div className="action-item-warp">
          <Select
            style={{ width: 100 }}
            defaultValue={inputType}
            onSelect={changeInputChange}
          >
            <Select.Option value={1}>有条码</Select.Option>
            <Select.Option value={0}>无条码</Select.Option>
          </Select>
        </div>
        <div className="action-item-warp">
          {inputType === 1 && (
            <Input
              placeholder="扫条码"
              style={{ width: 330 }}
              onPressEnter={(e) => {
                searchGoodsByCode({ type: 1, code: e.target.value });
                setTimeout(() => {
                  e.target.value = null;
                });
              }}
            />
          )}
          {inputType === 0 && (
            <Input.Search
              placeholder="输入序号"
              style={{ width: 330 }}
              onSearch={(value, e) => {
                searchGoodsByCode({ type: 2, code: value });
                setTimeout(() => {
                  e.target.value = null;
                });
              }}
            />
          )}
        </div>
        <div className="action-submit-btn">
          <strong>
            应付：<span style={{ color: "orangered" }}>222.22</span>
          </strong>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <span style={{ textDecoration: "line-through" }}>原价：222.22</span>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button type="primary">创建订单</Button>
        </div>
      </div>
      <div className="cashier-container">
        {data.map((item, index) => (
          <Card key={item.id} size="small" className="cashier-item">
            <FormItem label="品名" {...layoutItem}>
              <span title={item.goodsName} className="item-warp-goodsName">
                {item.goodsName}
              </span>
            </FormItem>
            <FormItem label="价格" {...layoutItem}>
              <strong className="price">{item.rootPrice}</strong>
            </FormItem>
            <FormItem label="数量" {...layoutItem}>
              <InputNumber
                value={item.count}
                precision={0}
                min={1}
                max={99}
                style={{ width: 60, textAlign: "center" }}
              />
              &nbsp;&nbsp; 个
            </FormItem>
            <FormItem label="活动" {...layoutItem}>
              <span className="actived">无</span>
            </FormItem>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default Cashier;
